import React, { useState } from "react";
import { Box, Typography, TextField, Button, Paper, Grid, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import { LocalizationProvider, DatePicker, TimePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; // Import AdapterDayjs for localization
import axios from "axios";
import { Dialog, DialogContent,DialogActions } from "@mui/material";


const AddAppointment = () => {
    const [password, setPassword] = useState("");
    const [validPassword, setValidPassword] = useState(false);
    const [appointmentDetails, setAppointmentDetails] = useState({
        selectedName: "",
        selectedEmail: "",
        selectedMobNo: "",
        selectedDate: null,
        selectedTime: null,
    });
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [error, setError] = useState("");

    const correctPassword = "9064";  // Password for accessing the page
    const navigate = useNavigate();  // Hook to navigate to other pages

    // Handler for password submission
    const handlePasswordSubmit = () => {
        if (password === correctPassword) {
            setValidPassword(true);
        } else {
            setError("Incorrect password, please try again.");
        }
    };

    // Handler for going back to the previous page
    const handleBack = () => {
        navigate("/");  // Navigate back to the homepage
    };

    const handleAppointmentChange = (e) => {
        const { name, value } = e.target;
        setAppointmentDetails({ ...appointmentDetails, [name]: value });
    };

    const handleSubmitAppointment = async() => {
        if (!appointmentDetails.selectedName || !appointmentDetails.selectedEmail || !appointmentDetails.selectedMobNo || !appointmentDetails.selectedDate || !appointmentDetails.selectedTime) {
            setSnackbarMessage("Please fill all the fields.");
            return;
        }            
            try{
                const checkResponse = await axios.post(`https://appointment-schedular-seven.vercel.app/booked-slots?date=${appointmentDetails.selectedDate}`);
        
                if (checkResponse.data.isBooked) {
                    setSnackbarMessage("Selected slot is already booked. Please choose another time.");
                    setSnackbarOpen(true);
                    return;
                }
                console.log("slot available")
                const response = await axios.post("https://appointment-schedular-seven.vercel.app/book-appointment", appointmentDetails );
                console.log(response)
                setSnackbarMessage("Appointment booked successfully! Please send this across whatsapp  to 9869405747 to confirm appoinment and payment process.");
                setSnackbarOpen(true);
                setAppointmentDetails({
                    selectedName: "",
                    selectedEmail: "",
                    selectedMobNo: "",
                    selectedDate: null,
                    selectedTime: null,
                });
        } catch(error){
            console.error("Error booking appointment:", error);
            setSnackbarMessage("Failed to book the appointment. Please try again.");
            setSnackbarOpen(true);
        }
        };

    return (
        <>
                    <Dialog
            open={snackbarOpen}
            onClose={() => setSnackbarOpen(false)}
            fullWidth
            maxWidth="sm"
            sx={{
                "& .MuiPaper-root": {
                    borderRadius: "16px",
                    padding: "20px",
                    backgroundColor: snackbarMessage.includes("successfully") ? "#e8f5e9" : "#ffebee",
                    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                },
            }}
        >
            <DialogContent
                sx={{
                    textAlign: "center",
                    fontSize: "1.5rem",
                    color: snackbarMessage.includes("successfully") ? "#4caf50" : "#f44336",
                    fontWeight: "bold",
                }}
            >
                {snackbarMessage}
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center" }}>
                <Button
                    onClick={() => setSnackbarOpen(false)}
                    variant="contained"
                    sx={{
                        backgroundColor: snackbarMessage.includes("successfully") ? "#4caf50" : "#f44336",
                        "&:hover": {
                            backgroundColor: snackbarMessage.includes("successfully") ? "#388e3c" : "#d32f2f",
                        },
                    }}
                >
                    OK
                </Button>
            </DialogActions>
        </Dialog>
        <Box sx={{ height: "100vh", backgroundColor: "#f4f7fc", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", paddingX: 2 }}>
            <Paper elevation={5} sx={{ padding: 4, borderRadius: 2, backgroundColor: "white", width: "100%", maxWidth: "600px", textAlign: "center", boxShadow: "0 10px 15px rgba(0, 0, 0, 0.1)", position: "relative" }}>
                {/* Back Button Positioned at Top Left of Card */}
                <Button
                    variant="outlined"
                    onClick={handleBack}
                    sx={{
                        position: 'absolute',
                        top: -10, // Position the button just above the card
                        left: -10, // Adjust left distance to be at the edge
                        padding: '6px 16px',
                        fontSize: '0.875rem',
                        color: "#1976d2",
                        borderColor: "#1976d2",
                        '&:hover': {
                            backgroundColor: "#e3f2fd",
                        },
                    }}
                >
                    Back
                </Button>

                {!validPassword ? (
                    <Box>
                        <Typography variant="h5" sx={{ marginBottom: 3, color: "#1976d2" }}>Enter Password to Add Appointment</Typography>
                        <TextField
                            type="password"
                            label="Password"
                            variant="outlined"
                            fullWidth
                            sx={{ marginBottom: 2 }}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <Button
                            variant="contained"
                            onClick={handlePasswordSubmit}
                            sx={{ marginBottom: 2, padding: "10px 20px" }}
                        >
                            Submit
                        </Button>
                        {error && <Alert severity="error">{error}</Alert>}
                    </Box>
                ) : (
                    <Box>
                        <Typography variant="h5" sx={{ marginBottom: 3, color: "#1976d2" }}>Add Appointment</Typography>

                        <TextField
                            label="Name"
                            variant="outlined"
                            fullWidth
                            sx={{ marginBottom: 2 }}
                            value={appointmentDetails.selectedName}
                            name="selectedName"
                            onChange={handleAppointmentChange}
                        />
                        <TextField
                            label="Email"
                            variant="outlined"
                            fullWidth
                            sx={{ marginBottom: 2 }}
                            value={appointmentDetails.selectedEmail}
                            name="selectedEmail"
                            onChange={handleAppointmentChange}
                        />
                        <TextField
                            label="Phone"
                            variant="outlined"
                            fullWidth
                            sx={{ marginBottom: 2 }}
                            value={appointmentDetails.selectedMobNo}
                            name="selectedMobNo"
                            onChange={handleAppointmentChange}
                        />

                        {/* Date Picker */}
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Date"
                                value={appointmentDetails.selectedDate}
                                onChange={(newValue) => setAppointmentDetails({ ...appointmentDetails, selectedDate: newValue })}
                                renderInput={(params) => <TextField {...params} fullWidth sx={{ marginBottom: 2 }} />}
                            />
                        </LocalizationProvider>

                        {/* Time Picker */}
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <TimePicker
                                label="Time"
                                value={appointmentDetails.selectedTime ? dayjs(appointmentDetails.selectedTime, "h:mmA") : null}
                                onChange={(newValue) => 
                                    setAppointmentDetails({ ...appointmentDetails, selectedTime: dayjs(newValue).format('h:mmA') })}
                                renderInput={(params) => <TextField {...params} fullWidth sx={{ marginBottom: 2 }} />}
                            />  
                        </LocalizationProvider>

                        <Button
                            variant="contained"
                            onClick={handleSubmitAppointment}
                            sx={{ padding: "10px 20px" ,marginTop:"20px"}}
                        >
                            Submit Appointment
                        </Button>
                    </Box>
                )}
            </Paper>
        </Box>
        </>
    );
};

export default AddAppointment;
